<div [hidden]="hidden" class="denomination">
  @if (field?.label || field?.tooltip) {
    <div class="group-heading">
      <h3 class="label">{{ field.label }}</h3>
      <app-form-tooltip [text]="field.tooltip" class="tooltip-content"></app-form-tooltip>
    </div>
  }

  <p class="description">{{ field?.description }}</p>
</div>

@for (field of field.fieldGroup; track field) {
  <formly-field [field]="field"> </formly-field>
}
